import * as React from 'react';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { CURRENT_ENV_ROLE_TYPE } from '../../utils/EnvConfigUtils';

/** Same teardrop as legacy DOM pin; viewBox keeps tip aligned with Mapbox `anchor: 'bottom'`. */
export const MAP_GALLERY_LOCATION_PIN_PATH =
	'M13.5 0C6.044 0 0 6.044 0 13.5c0 10.125 13.5 27.5 13.5 27.5S27 23.625 27 13.5C27 6.044 20.956 0 13.5 0zm0 18.281A4.781 4.781 0 1113.5 8.72a4.781 4.781 0 010 9.562z';

export const MAP_GALLERY_PIN_WIDTH = 20;
export const MAP_GALLERY_PIN_HEIGHT = 30;

export function MapGalleryPin(): React.ReactElement {
	const isSupplier = CURRENT_ENV_ROLE_TYPE === ROLE_TYPES.SUPPLIER;
	const linkColorClass = isSupplier ? 'text-supplier' : 'text-buyer';
	return (
		<div className={'mapbox-gallery__pin ' + linkColorClass}>
			<svg
				width={MAP_GALLERY_PIN_WIDTH}
				height={MAP_GALLERY_PIN_HEIGHT}
				viewBox="0 0 27 41"
				aria-hidden={true}
			>
				<path fill="currentColor" d={MAP_GALLERY_LOCATION_PIN_PATH} />
			</svg>
		</div>
	);
}
